import { Form, IFormContext }                                from 'rewire-ui';
import { UdfDocumentType }                                   from '../DataTypes';
import DataQueries                                           from '../graphql/Queries';
import { TEditLoadFn, TEditSaveFn, TEditDeleteFn, AccessFn } from './EditDialogModel';
import { UdfsContainerModel }                                from './UdfsModel';

export const DocumentSchema = `
  id
  code
  name
  tags
  fields
`;

export default class DocumentDialogModel<TState = unknown> extends UdfsContainerModel<TState> {
  public constructor(title: string, load: TEditLoadFn, insert: TEditSaveFn, update: TEditSaveFn, remove: TEditDeleteFn, documentType: UdfDocumentType, canAdd?: AccessFn, canEdit?: AccessFn, canDelete?: AccessFn) {
    super(title, load, insert, update, remove, documentType, {canAdd: canAdd, canEdit: canEdit, canDelete: canDelete});
  }

  protected _createForm(): Form {
    const form = Form.create((form: IFormContext) => {
      const otherFields = this.otherFields(form);
      return ({
        ...this.defaultFields(form),
        ...otherFields,
      });
    });

    return form;
  }

  protected defaultFields(form: IFormContext) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const self        = this;
    const tagSearcher = {
      async search(search?: string) {
        return await DataQueries.getTags(self.documentType ?? 'documents', search);
      },
      map(item?: any) {
        return Array.isArray(item) ? '' : (item || '');
      }
    };

    return ({
      name: form.string().label('Name').validators('required').placeholder('enter name').autoFocus(),
      code: form.string().label('Code').placeholder('enter code'),
      tags: form.multiselectautocomplete(tagSearcher, {chipLimit: 3, inputAdd: (v: string) => v}).label('Tags').placeholder('enter tags'),
    });
  }

  protected otherFields(_form: IFormContext) {
    return {};
  }
}
